import React from 'react';
import { Link } from 'react-router-dom'
import { Grid, List, ListItemButton, Typography, useTheme } from "@mui/material";
import { get_all_processedMedia, get_selected_processedMedia, setSelectedprocessedMedia } from "features/processedMedia/processedMedia-slice";
import { dispatch } from "store";
import { gridSpacing } from "store/constant";
import TitleService, { GetTimeSince } from "title-service";
import SubCard from "ui-component/cards/SubCard";
import ApprovedMediaComponent from "./ApprovedMediaComponent";
import MediaStatisticComponent from "./MediaStatisticComponent";
import UserMeasurementsComponent from "./UserMeasurementsComponent";
import WatchLaterTwoToneIcon from '@mui/icons-material/WatchLaterTwoTone'
import { useDispatch, useSelector } from "react-redux";
import { getUserClaims } from "features/application/application-slice";
import { get_all_processMediaFix } from 'features/processMediaFix/processMediaFix-slice'
import { get_all_media } from 'features/media/media-slice';
import { Box, Tab, Tabs } from '@mui/material'
import RedQuickTextField from './RedQuickTextField';
import Busy from './Busy'
import MainCard from 'ui-component/cards/MainCard';
import { TabPanel } from './TabPanel';
function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}
export default function MediaResourcesComponent(props: { children: any }) {
    const theme = useTheme()
    let dispatch = useDispatch()
    let claims = useSelector(getUserClaims)
    let processedMedia_list = useSelector(get_all_processedMedia)
    let processedMedia = useSelector(get_selected_processedMedia)
    let media_list = useSelector(get_all_media)
    let processMediaFix_list = useSelector(get_all_processMediaFix)
    const [mediaFilter, setMediaFilter] = React.useState(null)
    const [processedMediaId, setProcessedMediaId] = React.useState(null)
    const [stateId, setStateId] = React.useState(null)
    const [value, setValue] = React.useState(0)
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }

    return (
        <MainCard title={TitleService('Media Resources')}>
            <div>
                <Busy />
                <Tabs
                    value={value}
                    indicatorColor="primary"
                    onChange={handleChange}
                    sx={{
                        mb: 3,
                        minHeight: 'auto',
                        '& button': {
                            minWidth: 100,
                        },
                        '& a': {
                            minHeight: 'auto',
                            minWidth: 10,
                            py: 1.5,
                            px: 1,
                            mr: 2.25,
                            color: 'grey.600',
                        },
                        '& a.Mui-selected': {
                            color: 'primary.main',
                        },
                    }}
                    aria-label="simple tabs example"
                    variant="scrollable"
                >
                    <Tab
                        component={Link}
                        to="#"
                        label={TitleService('Requests')}
                        {...a11yProps(0)}
                    />
                    <Tab
                        component={Link}
                        to="#"
                        label={TitleService('User Measurements')}
                        {...a11yProps(1)}
                    />
                    <Tab
                        component={Link}
                        to="#"
                        label={TitleService('Approved Media')}
                        {...a11yProps(2)}
                    />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={12} sm={6} md={4} >
                            <SubCard title={TitleService('Requests')}>
                                <Grid container spacing={gridSpacing}>
                                    <RedQuickTextField title={TitleService('Filter')} value={mediaFilter || ''} onChange={(val) => {
                                        setMediaFilter(val);
                                    }} />
                                    <Grid item xs={12} sx={{
                                        maxHeight: 'calc(72vw)',
                                        overflow: 'auto'
                                    }}>
                                        <List>
                                            {(processedMedia_list || []).filter((pm => {
                                                if (mediaFilter) {
                                                    let name: any = '';
                                                    if (media_list?.length) {
                                                        let mediaItem = media_list.find((x: any) => x.id === pm.media || x.id === pm.mediaId);
                                                        name = mediaItem?.name || mediaItem?.description;
                                                    }
                                                    return `${name}`.toLowerCase().indexOf(`${mediaFilter}`.toLowerCase()) !== -1;
                                                }
                                                return true;
                                            })).map((pm, index) => {
                                                let name: any = '';
                                                if (media_list?.length) {
                                                    let mediaItem = media_list.find((x: any) => x.id === pm.media || x.id === pm.mediaId);
                                                    name = mediaItem?.name || mediaItem?.description;
                                                }
                                                return (
                                                    <ListItemButton key={index} selected={pm?.id === processedMedia?.id} onClick={() => {
                                                        dispatch(setSelectedprocessedMedia(pm?.id));
                                                        setStateId(null);
                                                        setProcessedMediaId(pm?.id);
                                                    }}>
                                                        <Grid item xs={12}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs zeroMinWidth>
                                                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                                        <div style={{
                                                                            height: 60,
                                                                            display: 'flex',
                                                                            marginRight: 10,
                                                                            borderRadius: '50%'
                                                                        }}>
                                                                            <img style={{
                                                                            }} src={pm.media?.thumbnail} />
                                                                        </div>
                                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                            <Typography align="left" component="div" variant="subtitle1">
                                                                                {name || pm?.name}
                                                                            </Typography>
                                                                            <Typography align="left" component="div" style={{
                                                                                whiteSpace: 'nowrap',
                                                                                maxWidth: 200,
                                                                                textOverflow: 'ellipsis',
                                                                                overflow: 'hidden'
                                                                            }} variant="subtitle2">
                                                                                {pm?.name || pm?.id}
                                                                            </Typography>
                                                                        </div>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Typography align="left" variant="caption">
                                                                        <WatchLaterTwoToneIcon sx={{
                                                                            fontSize: '0.875rem',
                                                                            marginRight: 0.2,
                                                                            verticalAlign: 'sub'
                                                                        }} />{GetTimeSince(pm.updated)}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </ListItemButton>
                                                )
                                            })}
                                        </List>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item xs={12} sm={6} md={8}>
                            <div>
                            </div>
                            <div>
                                <MediaStatisticComponent processedMedia={processedMedia} />
                            </div>
                            <div>
                                {props.children}
                            </div>

                        </Grid>
                    </Grid>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <UserMeasurementsComponent />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <ApprovedMediaComponent />
                </TabPanel>
            </div>
        </MainCard>
    )
}